<div><label class="filter-title">{{title}}</label></div>
<fieldset [attr.aria-label]="title">
  <div *ngFor="let brand of brands">
      <mat-checkbox
        class="result-filter-cb"
        tabindex="0"
        [checked]="brandIsSelected(brand)"
        (change)="onBrandFilterChange(brand)"
        (keyup.enter)="onBrandFilterChange(brand)">
        <span class="filter-label">{{brand}}</span>
      </mat-checkbox>
  </div>
</fieldset>
